const listActionsButtonsPosition = {
  install(Vue) {
    Vue.prototype.$listActionsButtonsPosition = function () {
      return this.$isMobileOrTablet() ? "left" : "right";
    };
  },
};

export default listActionsButtonsPosition;
